import { h, Fragment } from "preact"
import Skeleton from "preact-loading-skeleton";

export const ProductSkeleton = ({}) => {
  return (
    <Fragment>
      {[1,1,1,1].map(() => (
        <div class="col-3 ">
          <div class={ 'skeleton' }>
            <Skeleton/>
          </div>
          <Skeleton count={ 2 }/>
        </div>
      ))}
    </Fragment>
  )
}
